import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const setSnackbar = ({
  message,
  messageValues,
  severity,
  action,
  actionValues,
  isRaw,
  onClickAction,
}: {
  message: string;
  messageValues: Record<string, any> | null;
  severity: 'default' | 'error' | 'warning' | 'information' | 'success';
  action: string | null;
  actionValues: Record<string, any> | null;
  isRaw: boolean;
  onClickAction: (() => void) | null;
}) =>
  produce((draft: Draft<State>) => {
    draft.snackbar.message = message;
    draft.snackbar.messageValues = messageValues;
    draft.snackbar.action = action;
    draft.snackbar.actionValues = actionValues;
    draft.snackbar.severity = severity;
    draft.snackbar.isRaw = isRaw;
    draft.snackbar.onClickAction = onClickAction;
  });

export const clearSnackbar = () =>
  produce((draft: Draft<State>) => {
    draft.snackbar = initialState.snackbar;
  });
